// Types
import type { SelectOptionType } from "types"

export const headerLevelList: SelectOptionType[] = [
  {
    label: "Header",
    value: "1"
  },
  {
    label: "Sub Header",
    value: "2"
  },
  {
    label: "Detail",
    value: "3"
  }
]